import React, {memo} from 'react';

// Components
import TextTooltip from "../TextTooltip";

// Styles
import './style/category_badge.scss';


const CategoryBadge = ({category, className = ''}) => {
    return (
        <div className={`category_badge ${className}`} style={{ backgroundColor: category.color }}>
            <TextTooltip message={category.category_name}>
                <span className="category_badge_name">
                    {category.category_name}
                </span>
            </TextTooltip>
        </div>
    );
};

export default memo(CategoryBadge);
